import { createRouter, createWebHistory } from 'vue-router';
import SlideBar from '../views/SlideBar.vue';

const routes = [
  {
    path: '/',
    component: SlideBar,
    children: [
      {
        path: '',
        name: 'TaskList',
        component: () => import('../views/TaskList.vue'),
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/DashBoard.vue'),
      },
      {
        path: '/alert-manage',
        name: 'AlertManage',
        component: () => import('../views/AlertManage.vue'),
      },
      {
        path: '/dictionary',
        name: 'Dictionary',
        component: () => import('../views/MyDictionary.vue'),
      },
      {
        path: '/key-search',
        name: 'KeySearch',
        component: () => import('../views/KeysSearch.vue'),
      },
      {
        path: '/user-manage',
        name: 'UserManage',
        component: () => import('../views/UserManage.vue'),
      },
      {
        path: '/website',
        children: [
          {
            path: 'error-sensitive',
            name: 'WebsiteSensitive',
            component: () => import('../views/HomeView.vue'),
          },
          {
            path: 'link-availability',
            name: 'LinkAvailability',
            component: () => import('../views/LinkAvailability.vue'),
          },
          {
            path: 'home-update',
            name: 'HomeUpdate',
            component: () => import('../views/HomeUpdate.vue'),
          },
          {
            path: 'column-update',
            name: 'ColumnUpdate',
            component: () => import('../views/ColumnUpdate.vue'),
          },
          {
            path: 'error-statistics',
            name: 'ErrorStatistics',
            component: () => import('../views/ErrorStatistics.vue'),
          },
        ],
      },
      {
        path: '/wechat',
        children: [
          {
            path: 'error-sensitive',
            name: 'WeChatSensitive',
            component: () => import('../views/NewMedia.vue'),
          },
          {
            path: 'error-statistics',
            name: 'WeChatErrorStatistics',
            component: () => import('../views/MediaStatistics.vue'),
          },
        ],
      },
      {
        path: '/setting',
        name: 'Setting',
        component: () => import('../views/SettingPage.vue'),
      },
    ],
  },
  {
    path: '/free-mode/views',
    name: 'FreeMode',
    component: () => import('../views/FreePage.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "404" */ '../views/404Page.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_PATH),
  routes,
});

export default router;